
            import {Buffer} from "buffer";
            window.global = window;
            window.Buffer = window.Buffer || Buffer;
        